/**
 * Currently we stub interface in the client that does not do anything.
 */
var stubClient = {
  timing: function timing() {},
  increment: function increment() {},
  decrement: function decrement() {},
  histogram: function histogram() {},
  gauge: function gauge() {},
  distribution: function distribution() {},
  set: function set() {},
  event: function event() {},
  instrumented: function instrumented(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fn = arguments.length > 2 ? arguments[2] : undefined;

    // Handle optional options argument
    if (typeof options === 'function') {
      fn = options; // eslint-disable-line no-param-reassign

      options = {}; // eslint-disable-line no-param-reassign
    }

    return fn();
  },
  instrumentedSync: function instrumentedSync(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fn = arguments.length > 2 ? arguments[2] : undefined;

    // Handle optional options argument
    if (typeof options === 'function') {
      fn = options; // eslint-disable-line no-param-reassign

      options = {}; // eslint-disable-line no-param-reassign
    }

    return fn();
  }
};
export default stubClient;